module.exports = __webpack_public_path__ + "f542f18e9cf12cd7d0fa4b440f1a0195.woff";